import { Indicator, Root } from '@radix-ui/react-checkbox'
import { cn } from '@seen/ui'
import { IconCheck, IconMinus } from '@tabler/icons-react'
import type { JSX } from 'react'
import { Input } from '#src/components/core/input/Input.tsx'

interface DocumentPickerToolbarProps {
  search: string
  onSearchChange: (value: string) => void
  selectAllChecked: boolean | 'indeterminate'
  onSelectAllChange: () => void
  selectAllDisabled?: boolean
  className?: string
}

export function DocumentPickerToolbar({
  search,
  onSearchChange,
  selectAllChecked,
  onSelectAllChange,
  selectAllDisabled,
  className,
}: DocumentPickerToolbarProps): JSX.Element {
  return (
    <div className={cn('flex min-h-12 items-center gap-3 px-3', className)}>
      <Root
        aria-label="Select all"
        checked={selectAllChecked}
        disabled={selectAllDisabled}
        onCheckedChange={onSelectAllChange}
        className="size-4 shrink-0 rounded-[4px] border border-input outline-hidden transition-shadow focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground dark:bg-input/30 dark:data-[state=checked]:bg-primary"
      >
        <Indicator className="grid place-content-center text-current transition-none">
          {selectAllChecked === 'indeterminate' ? (
            <IconMinus className="size-3.5" />
          ) : (
            <IconCheck className="size-3.5" />
          )}
        </Indicator>
      </Root>
      <Input
        value={search}
        onChange={(event) => {
          onSearchChange(event.target.value)
        }}
        placeholder="Search documents"
        className="h-8"
      />
    </div>
  )
}
